module.exports = __webpack_public_path__ + "img/酒井宏伸.9d19d3af.jpg";